<template>
    <div class="d-flex justify-content-center align-items-center" :class="wrapperClass">
        <div class="d-inline-flex align-items-center text-muted">
            <AlertCircleOutlineIcon size="18" class="mr-1"/>
            <slot/>
        </div>
    </div>
</template>

<script>
import AlertCircleOutlineIcon from '@/common/components/svg-icons/AlertCircleOutlineIcon.vue';

export default {
    name: 'EmptyListMessage',
    props: {
        wrapperClass: {
            type: String,
            default: 'p-3'
        }
    },
    components: {
        AlertCircleOutlineIcon
    }
};
</script>
